import { FC } from "react";
import { Flex, Text } from "@chakra-ui/react";

interface CountdownTimeProps {
  value: number;
  label: string;
  fontSize?: string;
  fontColor?: string;
  labelSize?: string;
}

const CountdownTime: FC<CountdownTimeProps> = ({
  value,
  label,
  fontSize = "xl",
  fontColor = "white",
  labelSize = "xs",
}) => {
  return (
    <Flex direction="column" alignItems="center" gap="1" width="9">
      <Text fontWeight="bold" fontSize={fontSize} color={fontColor}>
        {String(value).padStart(2, "0")}
      </Text>
      <Text fontSize={labelSize} color={fontColor}>
        {label}
      </Text>
    </Flex>
  );
};

export default CountdownTime;
